import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FaceSdkService } from 'src/app/core/services/face-sdk.service';

@Component({
  selector: 'app-face-detection',
  templateUrl: './face-detection.component.html',
  styleUrls: ['./face-detection.component.scss']
})
export class FaceDetectionComponent implements AfterViewInit, OnDestroy {
  @ViewChild('sdkContainer', { static: true }) sdkContainer!: ElementRef;
  imageFace: string = '';
  nonce: string = '';
  sdkLicence: string = '';
  constructor(
    private faceSdkService: FaceSdkService,
    private renderer: Renderer2,
    public dialogRef: MatDialogRef<FaceDetectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.nonce = data.nonce;
    this.sdkLicence = data.sdkLicence;
  }
  async ngAfterViewInit() {
    const nonce = 'tb+ELCCtmQ61NB187tCmxS7psMCKnt+K2KCAgqsTAr4='; // nên tạo chuỗi ngẫu nhiên
    const el = this.sdkContainer.nativeElement as HTMLElement;
    const observer = new MutationObserver(() => {
      const wrapper = el.querySelector('#wrapper') as HTMLElement;
      if (wrapper) {
        this.renderer.setStyle(wrapper, 'translate', '-25px');
        observer.disconnect(); // Dừng theo dõi khi đã tìm thấy
      }
    });
  
    observer.observe(el, {
      childList: true,
      subtree: true
    });
    await this.faceSdkService.initialize(this.sdkContainer.nativeElement, this.sdkLicence);
    const result = await this.faceSdkService.startDetection(this.nonce ? this.nonce : nonce);
    if (result) {
      this.imageFace = 'data:image/png;base64,' + result.firstFace;
      const fileUpload = {
        name: 'face.png',
        imageBase64: 'data:image/png;base64,' + result.firstFace,
        faceImages: result.faceImages
      }
      console.log("ekyc check: result", result);
      
      if (result.firstFace) {
        this.dialogRef.close(fileUpload); 
      } else {
        this.dialogRef.close(); 
      }
     
    }
  }
  ngOnDestroy(): void {
    this.faceSdkService.destroy();
    // Optional: xóa nội dung DOM container nếu cần
    if (this.sdkContainer && this.sdkContainer.nativeElement) {
      this.sdkContainer.nativeElement.innerHTML = '';
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
